import { useSelector } from "react-redux";
import { RootState } from "newui/store";

export const useIsMenuCollapsed = (): boolean => {
  return useSelector((state: RootState) => state.appMenu.isCollapsed);
};
